module.exports = __webpack_public_path__ + "img/ss3.f2254446.png";